module.exports = __webpack_public_path__ + "static/media/trash-icon.30e9677a.svg";